import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class AccountOrganizationId extends IdValueObject {
  static create(value: string): AccountOrganizationId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new AccountOrganizationId(value);
  }
}
